import * as angular from 'angular';
import { config } from 'angular/utils/config';
import * as moment from 'pkp-moment-timezone-all-years';
import { DATES } from 'app/_constants/dates.constant';
import { USER_ROLES } from 'app/_constants/user-roles.constant';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';

export class PkpTsoAuctionTileCtrl implements ng.IController {
    public auctionTile: AuctionTileDto;
    public initializationError: boolean = null;
    public isLongTerm: boolean;
    public authenticated: boolean = false;
    public auctionListRoot = config.appBaseUrl + '/transport/auctions/list';

    public readonly COUNTDOWN_LABELS = {
        SUBMISSION_START: 'Submission start in',
        SUBMISSION_DEADLINE: 'Submission deadline in',
        PUBLICATION: 'Publication in',
        AUCTION_START: 'Starts in',
        AUCTION_CLOSE: 'Ends in'
    };

    constructor(
        private log,
        private $scope,
        private authService,
        private auctionsOverviewService: AuctionsOverviewService,
        public USER_ROLES: USER_ROLES,
        public DATES: DATES,
        private $location: ng.ILocationService
    ) {}

    $onInit(): void {
        try {
            this.isLongTerm = this.auctionsOverviewService.isLongTermAuction(
                this.auctionsOverviewService.getPeriodTypeByValue(
                    this.auctionTile.periodType
                )
            );
            this.initializationError = false;
        } catch (e) {
            this.initializationError = true;
            this.log.error(e.message);
        }

        this.authService.userLoginPromise.promise
            .then((res) => (this.authenticated = true))
            .catch((res) => (this.authenticated = false));
    }

    public getMilliseconds(dt) {
        return Date.parse(dt);
    }

    public getQuarter(d) {
        d = moment(d).format('M');
        const q = [1, 2, 3, 4];
        return 'Q' + q[Math.floor(d / 3)];
    }

    public getRuntimeStart(): string | Date {
        return this.auctionTile.runtimeList.sort((a, b) =>
            a.start.toString().localeCompare(b.start.toString())
        )[0].start;
    }

    public getRuntimeEnd() {
        return this.auctionTile.runtimeList.sort(
            (a, b) => -a.start.toString().localeCompare(b.start.toString())
        )[0].end;
    }
}

/**
 * @ngdoc component
 * @name pkpTsoAuctionTile
 * @memberof app
 *
 * @description
 * Ain't Nobody Got Time for That
 *
 * @param {object} auction The `AuctionTileDto` from the backend.
 * @param {boolean=} [showFooter=true] Whether or not to show the footer section of the tile. It contains user-specific
 *  information such as bids already placed on this auction and number of favored network points in this auction.
 *
 * @author flzemke.btc
 */
angular.module('app').component('pkpTsoAuctionTile', {
    template: require('app/_directives/pkp-tso-auction-tile.component.html'),
    controller: PkpTsoAuctionTileCtrl,
    controllerAs: 'tile',
    bindings: {
        auctionTile: '=',
        showFooter: '<'
    }
});
